<template>
  <BaseModal
        :id="'static'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_ext()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>
import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {
  name: "FormModal",
  props: [
      "title",
      "content_header",
      "rest_api",
      "notifications",
      "notyf",
      "array_options",
      "breadcrumb",
  ],

 components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons
    },

  data(){
      return{
        form_data:      FormResources.form_data,
        form_format:    FormResources.form_format,
        form_backup:    {...FormResources.form_data},
      }
  },

  methods: {

    total_time_calculation(start_time, end_time)
    {
      start_time  = start_time.split(":")
      end_time    = end_time.split(":")
      let start_date  = new Date(0, 0, 0, start_time[0], start_time[1], 0)
      let end_date    = new Date(0, 0, 0, end_time[0], end_time[1], 0)
      let diff        = end_date.getTime() - start_date.getTime()
      let hours       = Math.floor(diff / 1000 / 60 / 60)
      let result      = diff - hours * 1000 * 60 * 60
      let minutes     = Math.floor(result / 1000 / 60)
      if (hours < 0) 
      {
        hours = hours + 24
      }
      this.form_data.total_time = `${hours <= 9 ? "0" : ""}${hours}:${minutes <= 9 ? "0" : ""}${minutes}`
    },

    form_submit_ext()
    {
      if (this.form_data.start_time === "" && this.form_data.end_time === "") 
      {
        return false
      } 

      this.total_time_calculation(this.form_data.start_time, this.form_data.end_time)
      this.form_submit()
      
    }
    
  },

  mounted() {},
};
</script>